<template>
  <div class="button pointer-hover" transition="reveal">
    <symbol name="arrow-back-left"></symbol>
  </div>
</template>

<script>
import gsap from 'gsap'
import Symbol from './Symbol.vue'

export default {
  name: 'BackButton',
  components: {
    Symbol
  },
  transitions: {
    reveal: {
      enter (el, done) {
        gsap.set(this.$el, {opacity: 0, x: 10})
        gsap.to(el, 0.5, {opacity: 1, x: 0, onComplete: done})
      },
      leave (el, done) {
        gsap.to(el, 0.5, {x: 10, opacity: 0, onComplete: done})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.button {
  width: 44px;
  height: 100%;
  display: flex;
  align-items: center;
  position: absolute;
  top: 0px;
  left: 0px;

  .component-symbol {
    width: 7px;
    height: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// BackButton.vue?05715174